import { ActionType } from '../../abacus/enums/action-type.enum'
import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const targetGroupDefinition: ResourceDefinition = {
  title: 'Target Groups',
  nameSingular: 'Target Group',
  namePlural: 'Target Groups',
  className: 'TargetGroup',
  mainIdentifier: 'name',
  slug: 'taxonomies/target-groups',
  path: 'target-groups',
  icon: 'icon-grid',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [LinkType.CREATE],
  defaultLink: LinkType.EDIT,
  childrenThatPreventDelete: [],
  dropdownLinks: [
    {
      label: 'Edit',
      permission: 'editTaxonomies',
      action: (targetGroup) => ({
        type: ActionType.Link,
        link: {
          path: `${targetGroupDefinition.path}/${targetGroup.id}/edit`
        }
      })
    },
    {
      label: 'Delete',
      permission: 'deleteTaxonomies',
      action: (targetGroup) => ({
        type: ActionType.Delete,
        delete: {
          itemToDelete: targetGroup,
          definition: targetGroupDefinition
        }
      })
    }
  ]
}
